import { AUTO_POSITION } from '@prophecy/ui-v3/Graph/tokens';

import type { BaseProcessMetadata } from '@common/types';

/** Resolved graph coordinates: both `x` and `y` are always numbers (missing metadata uses `AUTO_POSITION`). */
export type ResolvedProcessMetadataPosition = { x: number; y: number };

export function getPosition(
  processMetadata: Pick<BaseProcessMetadata, 'x' | 'y'> | null | undefined
): ResolvedProcessMetadataPosition {
  return {
    x: processMetadata?.x ?? AUTO_POSITION,
    y: processMetadata?.y ?? AUTO_POSITION
  };
}
